import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HomeService } from '../../../../services/home.service';


import { LanguageServiceService } from '../../../../services/language-service.service';
import { LogoutService } from '../../../Authentication/auth/logout.service';
import { BehaviorSubject } from 'rxjs';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';

import { ExcelExportService } from '../../../../services/excel-export.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { PageEvent } from '@angular/material/paginator';
import Swal from 'sweetalert2';
import { UserService } from '../../../../services/user';
import { DeviceDetectorService } from '../../../../services/device-detector.service';

import e from 'express';
import { EmployeesService } from '../../../../services/employees';

@Component({
  selector: 'app-employeepagemobile',
  templateUrl: './employeepagemobile.component.html',
  styleUrl: './employeepagemobile.component.scss'
})
export class EmployeepagemobileComponent {

  allData: any[] = [];
  totalItems = 0;

  isAr: boolean = localStorage.getItem("language") == "ar";
  displayedColumns: string[] = ["name", 'job_title', 'salary', 'delete']

  imageURL = '/assets/Home.png';
  isActive = true;
  h5Active = false;
  arabicLag = false;
  classToggled: boolean = false;
  contentReady: boolean = true;
  noData: boolean = false;
  searched: boolean = false;
  searchTerm: any = [];

  focusOnSreach: boolean = false;
  AllCategoryactive: boolean = true;
  Medicinsactive: boolean = false;
  Injectionsactive: boolean = false;
  WheelChairsactive: boolean = false;
  isFilterDataOpen: boolean = false;
  FilterDataForm!: FormGroup;
  start_date?: string;
  end_date?: string;
  category_id?: number;
 
  city_id?: number;

  id?: string;
  quantity?: string;
  itemId?: string;
  stockTotal?: string;
  showRejectPopUp: boolean = false;
  isMobile: boolean = false;
  cartPopUp: boolean = false;
  accountType!: string;
  isAdmin!: boolean;
  isSubAdmin!: boolean;

  page: number = 1;
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private router: Router,
    private _employessService: EmployeesService,

    private deviceService: DeviceDetectorService,
    private _userService: UserService,
    private excelExportService: ExcelExportService
  ) {

    this.dataSource = new MatTableDataSource(this.allData);
  }

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();



    this._userService.getAccountType().subscribe({
      next: (data) => {

        this.accountType = data['user_type'];
        this.isAdmin = this.accountType == "1";
        this.isSubAdmin = this.accountType == "6";


        if (this.isAdmin || this.isSubAdmin) {
          this.getAllEmployees(1);
        }

      },
      error: (error) => console.error(error),
    });


  }
  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const windowHeight = window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;


    const bottomReached = scrollPosition + windowHeight >= pageHeight - 10; // use margin for tolerance

    if (this.page == 1)
      this.page = 2;

    if (bottomReached && !this.contentReady && this.page <= this.totalItems) {

      this.contentReady = true;
        this._employessService.getAllEmployees(this.page).subscribe({
          next: (data) => {
            console.log(this.totalItems)
            this.allData = [...this.allData, ...data['data']]

            this.page++;
            console.log(this.allData.length)


            this.contentReady = false;
            if (this.allData.length === 0) {
              this.noData = true;
            } else {
              this.noData = false;
            }
          },
          error: (error) => console.error(error),
        });
  
    }
  }
  deleteitem(id: string) {

    Swal.fire({
      title: this.isAr ? "متأكد؟؟" : "Are You Sure?",
      showCancelButton: true,
      confirmButtonText: this.isAr ? "نعم" : "YES",
      cancelButtonText: this.isAr ? "لا" : "no"
    }).then((result) => {
      if (result.isConfirmed) {
        this.contentReady = true;
        this._employessService.deleteEmployee(id).subscribe({
          next: (res) => {
            this.contentReady = false;
            this.getAllEmployees(1);
          },
          error: (err) => console.log(err),
        });
      }
    });

  }
  getAllEmployees(page: any) {
    this.contentReady = true;
    this.searched = false;
    this._employessService.getAllEmployees(page).subscribe({
      next: (data) => {
        this.allData = data['data'];
        this.totalItems = data['last_page'];
        this.contentReady = false;
        if (this.allData.length === 0) {
          this.noData = true;
        } else {
          this.noData = false;
        }
      },
      error: (error) => console.error(error),
    });
  }
  showEmployee(itemobj: any) {
    this.router.navigate(['/employee'], { queryParams: itemobj });
  }

  edit(itemobj: any) {
    this.router.navigate(['/addemployee'], { queryParams: itemobj });
  }
  formatDate(date: string): string {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear().toString().slice(2); // Getting last two digits of the year
    return `${day}-${month}-${year}`;
  }


}
